const it = {
  sinObra: "Senza cantiere",
  cat: { materiales: "Materiali", mano_obra: "Manodopera", subcontratas: "Subappalti", suministros: "Utenze", fiscal: "Fisco / Imposte" },
  rama: {
    albanil_oficial: "Muratore specializzato", fontanero: "Idraulico", electricista: "Elettricista", carpinteria_madera: "Falegnameria",
    carpintero_aluminio: "Serramentista alluminio", gestion_residuos: "Gestione rifiuti", transportes: "Trasporti",
    peones: "Manovali / Aiutanti", gestiones_comerciales: "Attività commerciali",
  },
  exento: { si: "Esente", marcar: "Segna come esente", marcado: "Spesa segnata come esente", quitado: "Spesa non più esente", error: "Impossibile aggiornare la spesa" },
  toast: {
    subida: "Immagine caricata", leyendo: "Immagine caricata · lettura dei dati della fattura…", leidos: "Dati della fattura letti automaticamente ✨",
    noLeidos: "Non è stato possibile leggere i dati automaticamente. Completali a mano.", errorSubir: "Impossibile caricare l'immagine",
    registrado: "Spesa registrata", eliminado: "Spesa eliminata",
  },
  jornada: {
    titulo: "Orario di lavoro per cantiere (limite {{n}}h/settimana)", totales: "{{n}}h totali",
    excesoObras: "{{n}} cantiere/i", excesoTexto: "superano le {{n}}h settimanali di manodopera. Controlla il carico di lavoro.",
    vacio: "Non ci sono ancora ore di manodopera. Aggiungi una spesa della categoria «Manodopera» indicando cantiere e ore.",
    semExcedidas: "{{n}} sett. superata/e", resumen: "{{h}}h · {{n}} settimana/e", excesoSemana: "{{h}}h oltre il limite legale di {{n}}h.",
  },
  coste: { titulo: "Costo per cantiere", ver: "Vedi Cantieri / Progetti →", obra: "Cantiere", materiales: "Materiali", manoObra: "Manodopera", total: "Costo totale" },
  vacio: { titulo: "Nessuna spesa", hint: "Registra fatture di materiali, manodopera e subappalti" },
  tabla: { concepto: "Descrizione", categoria: "Categoria", fecha: "Data", horas: "Ore", total: "Totale", justificante: "ricevuta", justificanteM: "Ricevuta" },
  form: {
    escanea: "Scansiona la fattura e compiliamo i dati", quitar: "Rimuovi immagine", leyendo: "Lettura…", camara: "Scansiona con la fotocamera",
    subir: "Carica file", analizando: "Analisi dell'immagine…",
    ocrBloqueado: "Puoi allegare l'immagine; la lettura automatica con IA è disponibile dal Piano Trimestrale.",
    concepto: "Descrizione", categoria: "Categoria", proveedor: "Fornitore / Azienda", base: "Imponibile (€)", impuesto: "Imposta",
    obra: "Cantiere / Progetto", irpf: "Ritenuta IRPF (professionisti)", sinRetencion: "Nessuna ritenuta",
    isp: "Inversione contabile (reverse charge)", ispNota: "(subappaltatore edile che ti fattura senza IVA né IGIC)",
    exento: "Esente da imposta", exentoNota: "(assicurazioni, tasse, affitto di abitazione…)",
    horas: "Ore", rama: "Settore di attività", datosFactura: "Dati della fattura", numero: "N. fattura", hora: "Ora di acquisto",
    nif: "NIF / CIF azienda", registro: "N. registro imprese", opcional: "Facoltativo", fecha: "Data",
  },
};

export default it;
